import { useCallback, useEffect, useState } from 'react';

/** Counts down once per second from `seconds`; `restart()` resets it (e.g. after "Resend code"). */
export function useCountdown(seconds: number) {
  const [remaining, setRemaining] = useState(seconds);

  useEffect(() => {
    if (remaining <= 0) return;
    const id = setTimeout(() => setRemaining((r) => r - 1), 1000);
    return () => clearTimeout(id);
  }, [remaining]);

  const restart = useCallback(() => setRemaining(seconds), [seconds]);
  return { remaining, done: remaining <= 0, restart };
}

/** 24 -> "0:24", 75 -> "1:15". */
export const formatCountdown = (total: number): string =>
  `${Math.floor(total / 60)}:${String(total % 60).padStart(2, '0')}`;
